import { useState } from 'react';

import { GetVerifiedBankAccountsResponse } from '@iwoca/lapi-client/edge';
import { Select } from '@iwoca/orion';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './BankDetailsActionDE.module.css';
import { AgreeDirectDebitMandateModal } from '../../../../modals/agreeDirectDebitMandateModal/AgreeDirectDebitMandateModal';

export const SelectVerifiedAccount = ({
    verifiedBankAccounts
}: {
    verifiedBankAccounts: NonNullable<GetVerifiedBankAccountsResponse['data']>;
}) => {
    const intl = useIntl();

    const [directDebitMandateModalOpen, setDirectDebitMandateModalOpen] =
        useState(false);

    const [selectedVerifiedAccountNumber, setSelectedVerifiedAccountNumber] =
        useState(
            verifiedBankAccounts.length === 1
                ? verifiedBankAccounts[0].number
                : ''
        );

    return (
        <div
            className={styles.stepItemContainer}
            data-testid="DE-add-bank-details"
        >
            <AgreeDirectDebitMandateModal
                isModalOpen={directDebitMandateModalOpen}
                onClose={() => setDirectDebitMandateModalOpen(false)}
            />
            <div className={styles.stepMessages}>
                <span className={styles.title}>
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details_title"
                        defaultMessage="Add your business bank details"
                    />
                </span>
                <span className={styles.caption}>
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details_caption"
                        defaultMessage="We’ll send the funds to this account."
                    />
                </span>
            </div>
            <div className={styles.buttonDropDownRow}>
                <div className={styles.dropdown}>
                    <Select
                        className={styles.accountNumberDropdown}
                        onChange={(e) => {
                            setSelectedVerifiedAccountNumber(e.target.value);
                        }}
                        defaultValue={selectedVerifiedAccountNumber}
                        placeholder={intl.formatMessage({
                            id: '_.funding_requirements.add_bank_details_dropdown_message',
                            defaultMessage:
                                'Please choose a verified bank account'
                        })}
                    >
                        <optgroup>
                            {verifiedBankAccounts.map((bankAccount) => (
                                <option
                                    key={bankAccount.number}
                                    value={bankAccount.number}
                                >
                                    {intl.formatMessage(
                                        {
                                            id: '_.select_payment_method.verified_bank_account_selected_value',
                                            defaultMessage: 'Account: {number}'
                                        },
                                        {
                                            number: bankAccount.number
                                        }
                                    )}
                                </option>
                            ))}
                        </optgroup>
                    </Select>
                </div>
                <div className={styles.button}>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setDirectDebitMandateModalOpen(true);
                        }}
                        disabled={!selectedVerifiedAccountNumber}
                    >
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details_open_direct_debit"
                            defaultMessage="Confirm Account"
                        />
                    </Button>
                </div>
            </div>
        </div>
    );
};
